'use client'

import { CSSVariablesResolver, v8CssVariablesResolver } from '@mantine/core'
import { Notifications } from '@mantine/notifications'
import { createTheme, defaultTheme, theme as themeOverride, ThemeProvider } from '@phoenix-web/mantine-v9'
import { crimsonPro, lato } from '@/lib/fonts'

export { ColorSchemeScript, mantineHtmlProps } from '@phoenix-web/mantine-v9'

// Compose v8 variable resolver with our app-specific overrides (dark.7 for dimmed)
const cssVariablesResolver: CSSVariablesResolver = (theme) => {
  const base = v8CssVariablesResolver(theme)
  return {
    variables: base.variables,
    light: {
      ...base.light,
      '--mantine-color-dimmed': theme.colors.dark[7],
    },
    dark: base.dark,
  }
}

// Create a theme instance. Add fonts for app.
const theme = createTheme({
  ...defaultTheme,
  fontFamily: `${lato.style.fontFamily}, ${themeOverride.fontFamily}`,
  headings: {
    ...defaultTheme.headings,
    fontFamily: `${crimsonPro.style.fontFamily}, ${themeOverride.headings!.fontFamily}`,
  },
})

export default function ThemeWrapper({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider defaultColorScheme="light" theme={theme} cssVariablesResolver={cssVariablesResolver}>
      {children}
      <Notifications position="top-center" pauseResetOnHover="notification" />
    </ThemeProvider>
  )
}
